export const TWELVE_DAYS_RANK_OFFER = 1430562;
